import ConfigDB from "../../../Config/ThemeConfig";
import { formatCompactTZS, formatTZS } from "../../../utils/format";

export const executivePrimary = ConfigDB.data.color.primary_color;
export const executiveSuccess = "#28a745";
export const executiveWarning = "#f59e0b";
export const executiveDanger = "#dc3545";
export const executiveGridColor = "#ecf3fa";

export const baseChartOptions = {
  chart: { toolbar: { show: false }, fontFamily: "inherit" },
  grid: { borderColor: executiveGridColor },
  legend: { position: "top" },
};

/** Area/line charts in dashboard cards — legend below title area, formatted tooltips. */
export const executiveAreaChartOptions = {
  ...baseChartOptions,
  chart: { ...baseChartOptions.chart, type: "area" },
  legend: {
    position: "bottom",
    horizontalAlign: "center",
    offsetY: 4,
    fontSize: "12px",
  },
  dataLabels: { enabled: false },
  tooltip: {
    y: {
      formatter: (value) => formatTZS(value),
    },
  },
  yaxis: {
    labels: {
      formatter: (value) => formatCompactTZS(value),
      style: { fontSize: "11px" },
    },
  },
};
